<template>
  <aqt-table refresh @on-refresh="refreshData" :pageDate="pageDate" @on-pageChange="refreshData">
    <div class="top" slot="operationLeft">
      <!-- 批量启用 -->
      <Button type="primary" @click="operatData(1)" size="small">{{ $t("m.nodisables_status") }}</Button>
      <!-- 批量禁用 -->
      <Button type="error" @click="operatData(2)" style="margin-left: 10px" size="small">{{ $t("m.disables_status") }}</Button>
      <Input v-model="query.name" search placeholder="姓名" @on-search="refreshData(1)" style="width: 200px; margin-left: 10px"/>
      <Input v-model="query.tel" search placeholder="手机号" @on-search="refreshData(1)" style="width: 200px; margin-left: 10px"/>
    </div>
    <Table border stripe :loading="tableLoading" :columns="columns" @on-selection-change="removeData" :data="data" slot="table"></Table>


  </aqt-table>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      pageDate: {
        total: 1,
        current_page: 1,
        per_page: 1,
      },
      data: [],
      columns: [
        {
          type: 'selection',
          width: 80,
          align: 'center'
        },
        {
          title: '姓名',
          minWidth: 100,
          align: 'center',
          key: 'name',
        },
        {
          title: '手机号',
          minWidth: 100,
          align: 'center',
          key: 'tel',
        },
        {
          title: '身份',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.user_type?this.user_typeList[params.row.user_type*1-1]:'')
          }
        },
        {
          title: '状态',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            let ss = params.row.status==1?'正常':'禁用'
            let colors = params.row.status==1?'green':'red'
            return h('div',{
              style:{
                color:colors
              }
            },ss)
          }
        },
      ],
      query:{
        library_id:localStorage.getItem('libId'),
        user_type:4,
        username:'',//用户名 用户类型是管理员
        name:'',//姓名 用户类型是编辑/专家/作者
        page:1,
        tel:'',//手机号 用户类型是编辑/专家/作者
      },
      del: [],
      user_typeList:['管理员','编辑','专家','作者']
    }
  },
  methods: {

    /************************************************************
     *
     * 单条删除
     * @param   {id}               id
     *
     ************************************************************/
    removeData (item) {
      this.del=item.map(e =>  e.users_id);
    },
    operatData (val) {
      if (!this.del.length) {
        this.$Message.warning('请选择要操作的内容');
        return;
      }
      this.$Modal.confirm({
        title: '操作确认',
        closable: true,
        loading: true,
        content: '您确定要修改状态吗?',
        onOk: () => {
          this.operatChange (val)
        }
      })
    },
    operatChange(val) {
      const _this = this;

      let cond = {
        library_id: localStorage.getItem('libId'),
        id:JSON.stringify(this.del),
        status: val,
      };
      // _this.$store.dispatch('saveUserBehavior', {
      //   path: _this.$route.path,
      //   name: '点击'+(val==2?'批量审核':'取消审核')+'按钮',
      //   other_id: _this.del.length==1?_this.del[0]:JSON.stringify(_this.del),
      //   type: 25,
      // }).then(() => {})

      _this.$httpsencrypt.post(`api/contributeweb/v3/users/ReviewOrCancel`,cond)
          .then((val) => {
            _this.$Modal.remove ()
            _this.refreshData (this.pageDate.current_page)
            _this.$Message.success('操作成功!');
            _this.del = [];
          })
          .catch((err) => {
            _this.$Modal.remove ()
            _this.$Message.warning('操作失败!');
          });
    },

    /************************************************************
     *
     * 列表数据
     *
     ************************************************************/
    queryData (index) {
      const _this = this
      _this.query.page = index
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/list`,_this.query)
          .then(val =>{
            _this.data = val.data;
            _this.tableLoading = false;
            _this.pageDate.current_page = val.pages.current_page;
            _this.pageDate.per_page = val.pages.per_page;
            _this.pageDate.total = val.pages.total;
          }).catch(err =>{
        _this.tableLoading=false;
      })
    },

    /************************************************************
     *
     * 刷新
     *
     ************************************************************/
    refreshData (index) {
      this.data = []
      this.tableLoading = true
      this.queryData (index ? index : 1)
    }
  },
  created() {
    this.refreshData ()
  },
};
</script>

<style lang="less" scoped>
</style>
